import { useState } from 'react';
import { Tooltip } from '@mui/material';
import { Flex } from '../../Flex';
import IconButton from '../../IconButton';
import SvgIcon from '../../SvgIcon';
import { ReactComponent as CopyIcon } from '../../../assets/copy.svg';
import { ReactComponent as VIcon } from '../../../assets/v.svg';

const CopyTooltipContent = ({ isCopied }: { isCopied: boolean }) => (
  <Flex sx={{ alignItems: 'center', gap: 0.5 }}>
    {isCopied && (
      <SvgIcon width={12} strokeColor="green">
        <VIcon />
      </SvgIcon>
    )}
    {isCopied ? 'Copied!' : 'Copy'}
  </Flex>
);

type Props = {
  content: string;
  strokeColor?: string;
  ariaLabel?: string;
};

const CopyButton = ({
  content,
  strokeColor = 'gray4',
  ariaLabel = 'Copy',
}: Props) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    setIsCopied(true);
  };

  return (
    <Tooltip title={<CopyTooltipContent isCopied={isCopied} />}>
      <IconButton
        aria-label={ariaLabel}
        onClick={handleCopy}
        onMouseLeave={() => setIsCopied(false)}
      >
        <SvgIcon width={14} strokeColor={strokeColor}>
          <CopyIcon />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
